export const getSpinningImageIdx = (isDesktop: boolean, thumbnailsCount: number, videosCount: number) => (isDesktop ? Math.min(4, thumbnailsCount) : Math.min(videosCount > 0 ? 2 : 3, thumbnailsCount));

const tireTypes = ["Classic / Muscle / Retro", "Truck / SUV", "Trailer",
  "Run Flat", "Performance", "Fuel Efficient", "EV", "All Terrain / Off Road / Mud", "Commercial (HD)"];

const wheelManufacturingTypes = ["Rotary Forged", "Stamped", "Flow Forged", "Flow Formed", "Cast"];
const wheelSpokesStylesTypes = [
  "V-Spokes",
  "Spider-Spokes",
  "Turbine-Spokes",
  "W-Spokes",
  "I-Spokes",
  "Spiral-Spokes",
  "5-Spokes",
  "Y-Spokes",
  "Flat-Spokes",
];

export const filterableAttributeSpriteImages = {
  tireTypes,
  typeV2s: tireTypes,
  nbcTires: ["utqgs", "tractions", "treadwears", "tractionRatings", "speedRatings", "loadIndexes", "sizes"],
  wheelsFilterableAttribute: ["material", "colors", "diameters", "widths", "boltPatterns", "offset"],
  wheelManufacturing: wheelManufacturingTypes,
  wheelManufacturings: wheelManufacturingTypes,
  wheelSpokesStyle: wheelSpokesStylesTypes,
  wheelSpokesStyles: wheelSpokesStylesTypes,

};

export const nbcAttributeImages = {
  tireTypes: "tire-types-sprite.png",
  typeV2s: "tire-types-sprite.png",
  wheelManufacturing: "wheel-manufacturing-sprite.png",
  wheelManufacturings: "wheel-manufacturing-sprite.png",
  wheelSpokesStyle: "wheel-spokes-style.png",
  wheelSpokesStyles: "wheel-spokes-style.png",
  nbcTires: "nbc-tires.png",
  wheelsFilterableAttribute: "wheels-filterable-attribute.png",
};
